import React from 'react';
import cn from 'classnames';
import '../Search.scss';

type Counts = { all: number; news: number; catalog: number; pages: number };

type Props = {
    activeTab: 'all' | 'news' | 'catalog' | 'pages';
    counts: Counts;
    handleSelectTab: (tab: 'all' | 'news' | 'catalog' | 'pages') => void;
    labels?: {
        all?: string;
        news?: string;
        catalog?: string;
        pages?: string;
    };
};

export const SearchFilters: React.FC<Props> = ({ activeTab, counts, handleSelectTab, labels }) => {
    const hasLabels = !!labels;
    const allLabel = (hasLabels && labels && labels.all) || 'All Content';
    const newsLabel = (hasLabels && labels && labels.news) || 'News';
    const catalogLabel = (hasLabels && labels && labels.catalog) || 'Catalog';
    const pagesLabel = (hasLabels && labels && labels.pages) || 'Pages';
    return (
        <div className="search-filters" role="tablist" >
            <button
                type="button"
                className={cn('search-filters__item  search-filters__item_all', {
                    active: activeTab === 'all',
                })}
                onClick={() => handleSelectTab('all')}
                role="tab"
                aria-selected={activeTab === 'all'}
            >
                {allLabel}
            </button>
            <button
                type="button"
                className={cn('search-filters__item', {
                    active: activeTab === 'news',
                })}
                onClick={() => handleSelectTab('news')}
                role="tab"
                aria-selected={activeTab === 'news'}
            >
                {newsLabel} <div className="search-filters__item-count">{counts.news}</div>
            </button>
            <button     
                type="button"
                className={cn('search-filters__item', {
                    active: activeTab === 'catalog',
                })}
                onClick={() => handleSelectTab('catalog')}
                role="tab"
                aria-selected={activeTab === 'catalog'}
            >
                {catalogLabel} <div className="search-filters__item-count">{counts.catalog}</div>
            </button>
            <button
                type="button"
                className={cn('search-filters__item', {
                    active: activeTab === 'pages',
                })}
                onClick={() => handleSelectTab('pages')}
                role="tab"
                aria-selected={activeTab === 'pages'}
            >
                {pagesLabel} <div className="search-filters__item-count">{counts.pages}</div>
            </button>
        </div>
    );
};


